import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

export default class extends Controller {
  static targets = ['extractionChart']

  static values = {
    url: String
  }

  charts = {}

  connect() {
    this.loadData()
  }

  disconnect() {
    Object.values(this.charts).forEach((chart) => chart.destroy())
    this.charts = {}
  }

  async loadData() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      this.renderChart(data)
    } catch (error) {
      console.error('Failed to load extraction stats:', error)
    }
  }

  renderChart(data) {
    if (!this.hasExtractionChartTarget || !data.daily_stats || data.daily_stats.length === 0) {
      if (this.hasExtractionChartTarget) {
        this.extractionChartTarget.innerHTML =
          '<p class="text-sm text-slate-400">No extraction data available</p>'
      }
      return
    }

    const canvas = document.createElement('canvas')
    this.extractionChartTarget.innerHTML = ''
    this.extractionChartTarget.appendChild(canvas)

    const dailyStats = data.daily_stats
    const labels = dailyStats.map((d) => this.formatDate(d.date))
    const successRates = dailyStats.map((d) => d.success_rate)
    const totals = dailyStats.map((d) => d.total)

    this.charts.extraction = new Chart(canvas, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Success Rate %',
            data: successRates,
            borderColor: '#10B981',
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            fill: true,
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 2,
            pointHoverRadius: 5,
            yAxisID: 'y'
          },
          {
            label: 'Total Tests',
            data: totals,
            borderColor: '#6366F1',
            backgroundColor: 'transparent',
            borderDash: [5, 5],
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 4,
            yAxisID: 'y1'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              padding: 8,
              font: { size: 10 }
            }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              font: { size: 9 },
              maxRotation: 0,
              maxTicksLimit: 10
            }
          },
          y: {
            type: 'linear',
            display: true,
            position: 'left',
            min: 0,
            max: 100,
            grid: { color: '#E2E8F0' },
            ticks: {
              font: { size: 9 },
              callback: (value) => `${value}%`
            }
          },
          y1: {
            type: 'linear',
            display: true,
            position: 'right',
            grid: { drawOnChartArea: false },
            ticks: { font: { size: 9 } }
          }
        }
      }
    })
  }

  formatDate(dateStr) {
    const date = new Date(dateStr)
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }
}
